/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import ReactMarkdown from 'react-markdown';
import { object } from 'prop-types';

const styles = (theme) => ({
    footerBody: {
        paddingLeft: '10px',
        paddingRight: '10px',
        '& h2': {
            color: theme?.palette?.footerDisclaimer || '#2e2c2c',
            fontFamily: theme?.typography?.fontFamily,
            fontSize: '30px',
            lineHeight: 1.2,
            fontWeight: 500,
            margin: '0',
        },
        '& h3': {
            color: theme?.palette?.footerDisclaimer || '#2e2c2c',
            fontFamily: theme?.typography?.fontFamily,
            fontSize: '30px',
            lineHeight: 1.2,
            fontWeight: 500,
            margin: '0',
        },
        '& p': {
            color: theme?.palette?.footerDisclaimer || '#2e2c2c',
            fontSize: '1rem',
            lineHeight: '1.5em',
        },
        '& a': {
            color: theme?.palette?.black || '#000',
            fontWeight: 700,
            letterSpacing: 0.5,
            textDecoration: 'none',
            backgroundColor: 'transparent',
        },
        '& li': {
            fontSize: '0.6875rem',
            lineHeight: '15px',
        },
        '& hr': {
            margin: 0,
            height: '1px',
            borderWidth: 0,
            backgroundColor: theme?.palette?.footerDisclaimer,
        },
    },

});

const GraphqlDisclaimer = ({ classes, disclaimerBlock }) => {
    if (disclaimerBlock?.copy) {
        return (
            <div id="disclaimer" className={classes.footerBody}>
                {
                    disclaimerBlock.copy && (
                        <ReactMarkdown
                            source={disclaimerBlock.copy}
                            skipHtml
                        />
                    )
                }
            </div>
        );
    }
    return null;
};

GraphqlDisclaimer.propTypes = {
    disclaimerBlock: object,
    classes: object.isRequired,
};
GraphqlDisclaimer.defaultProps = {
    disclaimerBlock: {},
};
export default withStyles(styles)(GraphqlDisclaimer);
